import React from "react";
import "./Spinner.css";

const spinner = props => {
  return <div className="Loader">Loading...</div>;
};

export default spinner;
